import React, { useState, useEffect } from "react";
import '../css/heading.css';
import PlaceholderLoading from 'react-placeholder-loading';
import { useMobileMediaQuery, useTabletMediaQuery } from "../utils";
import ImgIconEuroCoin from '../assets/svg/iconEuroCoin.svg';
import IconInfoHeader from '../assets/svg/iconInfoHeader.svg';
import IconConfig from '../assets/svg/iconConfig.svg';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend, setSaldoCarteira } from '../features/onboardingData/onboardingUserData';

const Heading = (props) => {

    const {
        hasBtnBack = true,
        hasSaldo = true,
        hasPadding = false,
        goHome = false
    } = props;

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const isSaldoCarteira = useSelector((state) => state.onboardingUserData.isSaldoCarteira);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const dispatch = useDispatch();

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleGoBackClick = () => {
        navigate(-1);
        dispatch(setStartSpend(false));
    };

    const handleGoHomeClick = () => {
        navigate('/');
        dispatch(setStartSpend(false));
    };

    const handleClickShowConfig = () => {
        navigate('/configuracoes');
    };

    const handleClickShowInfo = () => {
        window.open('https://saude360.medis.pt/apoio-ao-cliente', '_blank');
    };
    

    const mainViewSaldoContainerHeadingWithSaldo = hasPadding ? 
    ( isTablet ? 'titleSaldoContainerHeadingWithSaldoHasPadding' : ( isMobile ? 'titleSaldoContainerHeadingWithSaldoHasPaddingTablet' : 'titleSaldoContainerHeadingWithSaldoHasPaddingMobile') ) : 
    ( isTablet ? 'titleSaldoContainerHeadingWithSaldo' : ( isMobile ? 'titleSaldoContainerHeadingWithSaldoTablet' : 'titleSaldoContainerHeadingWithSaldoMobile') );

    const mainBtnBackViewSaldoContainerHeading = hasPadding ? 
    (  isTablet ? 'goBackBtnViewMbWayHeadingHasPadding' : ( isMobile ? 'goBackBtnViewMbWayHeadingHasPaddingTablet' : 'goBackBtnViewMbWayHeadingHasPaddingMobile' ) ) : 
    ( isTablet ? 'goBackBtnViewMbWayHeading' : ( isMobile ? 'goBackBtnViewMbWayHeadingTablet' : 'goBackBtnViewMbWayHeadingMobile' ) );

    return (
        <div className={ isTablet ? 'mainViewContainerHeading' : (isMobile ? 'mainViewContainerHeadingTablet' : ( hasBtnBack ? 'mainViewContainerHeadingMobile' : 'mainViewContainerNoBtnHeadingMobile' ))}>
            <div className={mainViewSaldoContainerHeadingWithSaldo}>
                <div className={ isTablet ? 'titleContainerHeadingWithSaldo' : ( isMobile ? 'titleContainerHeadingWithSaldoTablet' : 'titleContainerHeadingWithSaldoMobile')}>
                    <div className={ isTablet ? 'firstTitleViewHeadingWithSaldo' : ( isMobile ? 'firstTitleViewHeadingWithSaldoTablet' : 'firstTitleViewHeadingWithSaldoMobile')}>
                        { isTablet ?(
                            <div className='textTitleBoldHeadingWithSaldo'>Carteira Virtual Médis</div> ) : (
                            <>
                            <div className='textTitleRegularHeadingWithSaldoMobile'>Carteira</div>
                            <div className='textTitleBoldHeadingWithSaldoMobile'>Virtual Médis</div>
                            </>
                        )}      
                    </div>
                    <div className='firstTitleViewConfigOnfoHeadingWithSaldo'>
                        <button className='infoHeaderIonBtnHeadingWithSaldo'  type='button' onClick={handleClickShowConfig} >
                            <span className='txtConfigTitleHeadingWithSaldo'><img className="iconHeadingViewWithSaldo" src={IconConfig} alt="imagem" /></span> <span className='txtConfigTitleHeadingWithSaldo'>Configurações</span>
                        </button>
                        <div className="deviderViewConfigOnfoHeadingWithSaldo"></div>
                        <button className='infoHeaderIonBtnHeadingWithSaldo'  type='button' onClick={handleClickShowInfo} >
                            <span className='txtConfigTitleHeadingWithSaldo'><img className="iconHeadingViewWithSaldo" src={IconInfoHeader} alt="imagem" /></span> <span className='txtInfoTitleHeadingWithSaldo'>Como funciona</span>
                        </button>   
                    </div>
                </div>
                { hasSaldo &&
                    <div className={ isTablet ? 'saldoContainerHeading' : ( isMobile ? 'saldoContainerHeadingWithSaldoTablet' : 'saldoContainerHeadingWithSaldoMobile')}>
                        { isLoading ? <PlaceholderLoading shape="rect" width={350} height={50}/> : (
                            <>
                            <div>
                                <span className={ isTablet ? 'txtRegSaldoHeadingWithSaldo' : ( isMobile ? 'txtRegSaldoHeadingWithSaldoTablet' : 'txtRegSaldoHeadingWithSaldoMobile')}>O meu </span>
                                <span className={ isTablet ? 'txtBoldSaldoHeadingWithSaldo' : ( isMobile ? 'txtBoldSaldoHeadingWithSaldoTablet' : 'txtBoldSaldoHeadingWithSaldoMobile')}>Saldo</span>
                            </div>
                            <div className='saldoInfoContainerHeadingWithSaldo'>
                                <div className="saldoEuroIconViewHeadingWithSaldo">
                                    <img src={ImgIconEuroCoin} alt="€" className="saldoEuroIconHeadingWithSaldo" />
                                </div>
                                <div className={isStatusCarteira === '2' ? 'txtRegularSaldoHeadingWithSaldoSus' : 'txtRegularSaldoHeadingWithSaldo'}>{`${isSaldoCarteira}€`}</div>
                            </div>
                            </>
                        )}
                    </div>
                }
            </div>
            { hasBtnBack &&
                <div className={ isTablet ? 'thirdMainContainerHeading' : ( isMobile ? 'thirdMainContainerHeadingTablet' : 'thirdMainContainerHeadingMobile') }>
                    <div className={mainBtnBackViewSaldoContainerHeading}>
                        <button className='txtGoBackBtnHeading'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                            <FaArrowLeftLong className='goBackIconHeading' /> Voltar
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default Heading;